import 'react-multi-carousel/lib/styles.css';
import * as React from 'react';
import { useRouter } from 'next/router';
import Monitoring from '../components/monitoring/Monitoring';
import { useCallback, useEffect, useRef } from 'react';

import { xVerifyService } from 'services';
import { checkEmail } from '../helpers/emailChecker';
import { usePrevious } from '../hooks';
import ProductChat from '../components/product/ProductChat';
import ProductHeader from "components/product/ProductHeader";
import ProgressBar from 'components/atomic/ProgressBar';
import { NextSeo } from 'next-seo';
import { config } from '_config';

const steps = ["Step 1", "Step 2" ];

export default function TrademarkMonitoringReport() {
  const router = useRouter();
  const rightSide = useRef();

  const [state, setState] = React.useState({
    code: 'TRADEMARK_Trademark_Monitoring',
    trademarkName: null,
    firstName: null,
    lastName: null,
    phone: null,
    email: null,
    verifying: false,
    verificationResult: {},
    step: 0,
  });

  const prevState = usePrevious(state);

  const verifyEmail = useCallback(() => {
    if (!state.verificationResult?.email && checkEmail(state.email)) {
      setState((prevState) => ({ ...prevState, verifying: true }));

      xVerifyService.verifyEmail(state.email).then((result) => {
        setState((prevState) => {
          return {
            ...prevState,
            verificationResult: {
              ...prevState.verificationResult,
              email: result,
            },
            verifying: false,
          };
        });
      });
    }
  }, [state]);

  const handleBlur = useCallback(
    (e) => {
      const { type } = e.target;
      if (type === 'email') {
        verifyEmail();
      }
    },
    [verifyEmail]
  );

  useEffect(() => {
    const product = JSON.parse(localStorage.getItem('product'));
    const historyPath = localStorage.getItem('path');
    if (
      historyPath &&
      historyPath === 'trademark-monitoring-report' &&
      product
    ) {
      window.scrollTo(0, 0);
      setState({ ...product });
    }
  }, []);

  function handleChange(e) {
    if (e.target.name) {
      if (e.target.type === 'email') {
        setState({
          ...state,
          [e.target.name]: e.target.value,
          verificationResult: {
            ...state.verificationResult,
            [e.target.name]: null,
          },
        });
        localStorage.setItem(
          'product',
          JSON.stringify({
            ...state,
            [e.target.name]: e.target.value,
            verificationResult: {
              ...state.verificationResult,
              [e.target.name]: null,
            },
          })
        );
      } else {
        setState({ ...state, [e.target.name]: e.target.value });
        localStorage.setItem(
          'product',
          JSON.stringify({ ...state, [e.target.name]: e.target.value })
        );
      }
    } else {
      if (e.target.type === 'email') {
        setState({
          ...state,
          [e.target.id]: e.target.value,
          verificationResult: {
            ...state.verificationResult,
            [e.target.id]: null,
          },
        });
        localStorage.setItem(
          'product',
          JSON.stringify({
            ...state,
            [e.target.id]: e.target.value,
            verificationResult: {
              ...state.verificationResult,
              [e.target.id]: null,
            },
          })
        );
      } else {
        setState({ ...state, [e.target.id]: e.target.value });
        localStorage.setItem(
          'product',
          JSON.stringify({ ...state, [e.target.id]: e.target.value })
        );
      }
    }
    localStorage.setItem('path', 'trademark-monitoring-report');
  }

  function handleStep(value) {
    setState({ ...state, step: value });
    localStorage.setItem('product', JSON.stringify({ ...state, step: value }));
    localStorage.setItem('path', 'trademark-monitoring-report');
    router.push('/trademark-monitoring-report?step=' + value, undefined, {
      shallow: true,
    });
  }

  useEffect(() => {
    if (router.query.step)
      setState({ ...state, step: parseInt(router.query.step, 10) });
  }, [router.query.step]);

  useEffect(() => {
    if (prevState?.email === null) {
      verifyEmail();
    }
  }, [prevState, verifyEmail]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      rightSide.current?.scrollIntoView();
    });

    return () => {
      clearTimeout(timeout);
    };
  }, [rightSide.current]);

  useEffect(() => {
    let timeout;

    function handleRouteChangeComplete() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      });
    }

    router.events.on('routeChangeComplete', handleRouteChangeComplete);

    return () => {
      clearTimeout(timeout);
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, []);

  return (
    <div className="reg" ref={config.skin === 'v2-basic' ? rightSide : null}>
      <NextSeo title="Trademark Monitoring" />
      {config.skin === 'v2-basic' && (
        <div className="filing-banner-outer-container">
          <div className="filing-banner-inner-container">
            <ProductHeader header="Trademark Monitoring Questionnaire" />
            <ProgressBar value={state.step + 1} maxValue={steps.length} />
          </div>
        </div>
      )}
      <div className="side-wrapper">
        <div className="left-side">
          <div className="banner">
            <div className="summary">
              <h3>Trademark Monitoring Summary</h3>
              <div className="step-box">
                <h5 style={{ textTransform: 'uppercase' }}>Mark to monitor</h5>
                {state.trademarkName ? <p>{state.trademarkName}</p> : ''}
              </div>
              {state.step > 0 ? (
                <div className="step-box">
                  <h5 style={{ textTransform: 'uppercase' }}>
                    Contact Information
                  </h5>
                  <p>
                    {state.firstName ? state.firstName : ''}{' '}
                    {state.lastName ? state.lastName : ''}
                  </p>
                  <p>
                    {state.phone ? state.phone : ''}{' '}
                    {state.email ? state.email : ''}
                  </p>
                </div>
              ) : null}
              <ProductChat />
            </div>
          </div>
        </div>
        <div className="right-side" id="rightSide" ref={config.skin === 'v2-basic' ? null : rightSide}>
          <div className="form">
            <Monitoring
              state={state}
              onChange={handleChange}
              onBlur={handleBlur}
              onStep={handleStep}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
